<template>
  <div class="link-label-container">
    <div class="heading is-bold">
      Link Label
    </div>
    <div class="text-blocks">
      <div>
        To link a label you will need to use our mobile app
      </div>
      <div>
        Your mobile device needs to have NFC to identify a label
      </div>
      <AppStoreLinks
        is-narrow
        @store-click="trackClick"
      />
    </div>
    <Button
      text="Close"
      :on-click="goBack"
      is-text
      is-light
      has-padding
    />
  </div>
</template>

<script>
import Button from '../../components/atoms/button/button';
import AppStoreLinks from '../../components/atoms/links/app-store-links';
import { routeNames } from '../../constants';

export default {
  name: 'LinkLabel',
  components: {
    Button,
    AppStoreLinks,
  },
  methods: {
    goBack() {
      if (this.$route.name === routeNames.assets.linkAssetLabel) {
        this.$router.push({
          name: routeNames.assets.detail,
          params: {
            id: this.$route.params.id,
            teamId: this.$route.params.teamId,
          },
        });
      } else {
        this.$router.push({ name: routeNames.assets.list });
      }
    },
    trackClick(platform) {
      this.$root.trackEvent.clickAppStoreLink(
        platform,
        'Link Label',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
@import '@/styles/_breakpoints.scss';
.link-label-container {
  height: 100%;
  background-color: rgba($black, 0.85);
  color: $white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
  .heading {
    font-size: 1.125rem;
  }
  .text-blocks {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-around;
    padding: 0 20px;
  }
}
</style>
